var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCo2Meter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 79,
    viewBox: "0 0 161 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1631 78.585C4.62823 58.9032 12.52 40.4674 26.5047 26.499C33.5952 19.4161 42.0131 13.7976 51.2777 9.96428C60.5423 6.13101 70.472 4.15804 80.5 4.15804C90.528 4.15804 100.458 6.13101 109.722 9.96428C118.987 13.7976 127.405 19.4161 134.495 26.499C148.48 40.4674 156.372 58.9032 156.837 78.585H161C160.535 57.7917 152.211 38.3115 137.438 23.5578C122.229 8.36264 102.009 0 80.5 0C58.9907 0 38.771 8.36264 23.5621 23.5578C8.7894 38.3115 0.465129 57.7917 0 78.585H4.1631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.088 8.6199H79.9156V21.4346H81.088V8.6199Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.519 44.6588L132.355 51.0671L132.941 52.0842L144.104 45.676L143.519 44.6588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.138 17.9948L109.714 29.0898L110.727 29.6751L117.151 18.5801L116.138 17.9948Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1957 44.2083L17.6104 45.2209L28.7227 51.6291L29.308 50.6166L18.1957 44.2083Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8657 17.9943L43.8521 18.5789L50.2677 29.6784L51.2814 29.0938L44.8657 17.9943Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5273 8.95267L72.3632 9.07488L72.8769 13.9569L74.041 13.8347L73.5273 8.95267Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0446 10.0809L64.8977 10.324L65.9179 15.126L67.0648 14.8829L66.0446 10.0809Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.722 11.9712L57.6086 12.3321L59.1257 17.0013L60.2391 16.6404L58.722 11.9712Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6399 14.6212L50.5686 15.097L52.5652 19.5826L53.6365 19.1068L51.6399 14.6212Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4683 8.94821L86.9503 13.8298L88.1143 13.953L88.6323 9.07143L87.4683 8.94821Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.952 10.0725L93.9344 14.875L95.0814 15.1175L96.099 10.3149L94.952 10.0725Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.28 11.9709L100.763 16.6401L101.877 17.001L103.394 12.3318L102.28 11.9709Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.356 14.6123L107.36 19.0979L108.431 19.5737L110.428 15.0881L109.356 14.6123Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.561 74.3653L147.436 73.2019L152.324 72.6893L152.449 73.8527L147.561 74.3653Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.088 65.2216L146.28 66.2372L146.522 67.381L151.33 66.3654L151.088 65.2216Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.065 57.9447L144.391 59.4601L144.752 60.5721L149.427 59.0568L149.065 57.9447Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.297 50.9344L141.805 52.9263L142.281 53.9967L146.773 52.0047L146.297 50.9344Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7208 21.3094L37.7711 21.9887L40.6205 25.9633L41.5701 25.2841L38.7208 21.3094Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1008 26.306L32.2218 27.0809L35.4738 30.7615L36.3528 29.9866L33.1008 26.306Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.654 31.5518L26.8622 32.4129L30.4802 35.7324L31.272 34.8714L27.654 31.5518Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7904 37.335L22.0927 38.2737L26.0387 41.1999L26.7364 40.2611L22.7904 37.335Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.05 38.4738L135.047 41.3223L135.726 42.2745L139.729 39.426L139.05 38.4738Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.295 32.5831L130.611 35.8327L131.387 36.7104L135.071 33.4609L134.295 32.5831Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.95 27.2312L125.629 30.8467L126.491 31.6372L129.813 28.0217L128.95 27.2312Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M123.09 22.485L120.161 26.4249L121.101 27.1218L124.029 23.1819L123.09 22.485Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4407 74.3653L8.55298 73.8527L8.67791 72.6893L13.5637 73.2019L13.4407 74.3653Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92089 65.2382L9.67773 66.3819L14.4851 67.4017L14.7283 66.258L9.92089 65.2382Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.936 57.9443L11.5747 59.0564L16.2493 60.5717L16.6106 59.4596L11.936 57.9443Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7076 50.9258L14.2313 51.9958L18.7221 53.9901L19.1984 52.9201L14.7076 50.9258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2Meter);
export default __webpack_public_path__ + "static/media/co2meter.6316b8973b6d09e6b18383864edbaeb4.svg";
export { ForwardRef as ReactComponent };